import {
  HOME_LOCATION,
  SQUAD_LOCATION,
  STRATEGY_LOCATION,
  TRANSFER_DEALS_LOCATION,
  TRANSFER_SEARCH_LOCATION,
  FINANCE_LOCATION,
  HOME_STORAGE,
  SQUAD_STORAGE,
  STRATEGY_STORAGE,
  DEALS_STORAGE,
  SEARCH_STORAGE,
  FINANCE_STORAGE,
  PLAYER_INFO_STORAGE,
} from './constants';

export const ALL_TOUR_STORAGE_KEYS = [
  HOME_STORAGE,
  SQUAD_STORAGE,
  STRATEGY_STORAGE,
  DEALS_STORAGE,
  SEARCH_STORAGE,
  FINANCE_STORAGE,
  PLAYER_INFO_STORAGE,
];

export const locationToStorage = (location, additionalParam = false) => {
  if (location === HOME_LOCATION) {
    return localStorage.setItem(HOME_STORAGE, true);
  }
  if (location === SQUAD_LOCATION) {
    return additionalParam
      ? localStorage.setItem(PLAYER_INFO_STORAGE, true)
      : localStorage.setItem(SQUAD_STORAGE, true);
  }
  if (location === STRATEGY_LOCATION) {
    return localStorage.setItem(STRATEGY_STORAGE, true);
  }
  if (location === TRANSFER_DEALS_LOCATION) {
    return localStorage.setItem(DEALS_STORAGE, true);
  }
  if (location === TRANSFER_SEARCH_LOCATION) {
    return localStorage.setItem(SEARCH_STORAGE, true);
  }
  if (location === FINANCE_LOCATION) {
    return localStorage.setItem(FINANCE_STORAGE, true);
  }
};

export const skipAllTours = () => {
  ALL_TOUR_STORAGE_KEYS.forEach((key) => localStorage.setItem(key, 'true'));
};

export const resetAllTours = () => {
  ALL_TOUR_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

const REPLAY_TOURS_KEY = 'tol-replay-tours';

export const isWelcomeDone = () =>
  Boolean(
    typeof localStorage !== 'undefined' &&
      localStorage.getItem('hideWelcomePopup')
  );

export const shouldAutoStartTour = () => {
  try {
    if (sessionStorage.getItem(REPLAY_TOURS_KEY) === '1') return true;
  } catch (error) {
    /* private mode */
  }
  return !isWelcomeDone();
};

export const enableTourReplay = () => {
  try {
    sessionStorage.setItem(REPLAY_TOURS_KEY, '1');
  } catch (error) {
    /* private mode */
  }
};

export const tourStorageValue = {
  [HOME_LOCATION]: HOME_STORAGE,
  [SQUAD_LOCATION]: SQUAD_STORAGE,
  [STRATEGY_LOCATION]: STRATEGY_STORAGE,
  [TRANSFER_DEALS_LOCATION]: DEALS_STORAGE,
  [TRANSFER_SEARCH_LOCATION]: SEARCH_STORAGE,
  [FINANCE_LOCATION]: FINANCE_STORAGE,
};
